import { Dropdown, SelectOption } from "components/dropdown/Dropdown";
import { useField } from "formik";
import { Droppable } from "react-beautiful-dnd";
import { options } from "yargs";
import {
  ParsedWorkflowItem,
  ReferenceData,
  UnParsedTasksAndMilestones,
  WorkflowBuilderErrors,
  WorkflowReferenceDataNames,
} from "../WorkflowBuilderPage";
import { SetStateAction, useEffect, useState } from "react";
import {
  changeWorkflowBuilderReferenceData,
  updateWorkflowBuilderValue,
} from "./WorkflowItem";
import _ from "lodash";
import { List } from "./MilestoneTaskPicker";
import { MultiDropdown } from "components/dropdown/MultiDropdown";
import { EditNode } from "./DocumentUploadTrigger";
import dragAndDropIcon from "assets/drag_and_drop_icon.png";
import MilestoneTaskList from "./MileStoneTaskList";
import ToastMessage, { toastConfig } from "helpers/ToastMessage/ToastMessage";
import { toast } from "react-toastify";
interface Props {
  fieldName: string;
  selectOptions: SelectOption[];
  projectOptions: SelectOption[];
  triggerDatesOptions: SelectOption[];
  type: "trigger" | "action";
  parentOrderNumber: number;
  orderNumber: number;
  triggerData: any;
  parsedData: ParsedWorkflowItem | null;
  setParsedData: React.Dispatch<SetStateAction<ParsedWorkflowItem | null>>;
  uniqueId: string;
  referenceData: ReferenceData | null;
  setReferenceData: React.Dispatch<SetStateAction<ReferenceData | null>>;
  tempTriggerMilestoneId: number | null;
  setTempTriggerMilestoneId: React.Dispatch<SetStateAction<number | null>>;
  tempTriggerMilestoneData: List | null;
  setTempTriggerMilestoneData: React.Dispatch<SetStateAction<List | null>>;
  showTriggerTypeSelector: boolean;
  setShowTriggerTypeSelector: React.Dispatch<SetStateAction<boolean>>;
  workflowBuilderErrors: WorkflowBuilderErrors;
  milestonestasksList: List[] | null;
  unParsedTasksAndMilestones: UnParsedTasksAndMilestones | null;
}

const MilestoneUpdateTrigger: React.FC<Props> = ({
  fieldName,
  selectOptions,
  projectOptions,
  triggerDatesOptions,
  type,
  parentOrderNumber,
  orderNumber,
  triggerData,
  parsedData,
  setParsedData,
  uniqueId,
  referenceData,
  setReferenceData,
  tempTriggerMilestoneId,
  setTempTriggerMilestoneId,
  tempTriggerMilestoneData,
  setTempTriggerMilestoneData,
  showTriggerTypeSelector,
  setShowTriggerTypeSelector,
  workflowBuilderErrors,
  milestonestasksList,
  unParsedTasksAndMilestones,
}) => {
  const [overwriteExisting, setOverwriteExisting] = useState<boolean>(false);
  const [relevantErrors, setRelevantErrors] = useState<string[] | null>(null);
  const [milestone, setMilestone] = useState<SelectOption | null>(null);

  useEffect(() => {
    if (
      milestonestasksList &&
      Array.isArray(milestonestasksList) &&
      triggerData &&
      triggerData.milestonesID &&
      typeof triggerData.milestonesID === "number" &&
      milestonestasksList.filter(
        item => triggerData.milestonesID === item.tasksId
      ).length === 1
    ) {
      const data = milestonestasksList.filter(
        item => triggerData.milestonesID === item.tasksId
      )[0];

      setMilestone({
        label: data.tasksName,
        value: data.tasksId,
      });
    } else {
      setMilestone(null);
    }
  }, [milestonestasksList, triggerData]);

  useEffect(() => {
    if (
      workflowBuilderErrors &&
      workflowBuilderErrors.trigger &&
      workflowBuilderErrors.trigger.hasOwnProperty(0)
    ) {
      const tempErrors = workflowBuilderErrors.trigger[0];

      if (Array.isArray(tempErrors) && tempErrors.length > 0) {
        setRelevantErrors(tempErrors);
      } else {
        setRelevantErrors(null);
      }
    } else {
      setRelevantErrors(null);
    }
  }, [workflowBuilderErrors]);

  useEffect(() => {
    handleChangeMilestone(tempTriggerMilestoneData);

    if (
      tempTriggerMilestoneData &&
      tempTriggerMilestoneId &&
      milestonestasksList
    ) {
      const match = milestonestasksList.filter(
        item => item.tasksId === tempTriggerMilestoneId
      );

      if (match.length === 1) {
        const matchType = unParsedTasksAndMilestones
          ? unParsedTasksAndMilestones.filter(
              item => item.id === match[0].tasksId
            )
          : null;

        if (
          Array.isArray(matchType) &&
          matchType.length === 1 &&
          matchType[0].type !== "task"
        ) {
          setMilestone({
            label: match[0].tasksName,
            value: match[0].tasksId,
          });
        } else if (
          Array.isArray(matchType) &&
          matchType.length === 1 &&
          matchType[0].type === "task"
        ) {
          toast(
            <ToastMessage
              toastData={[
                {
                  title: "Only milestones allowed",
                  text: "Please only use Milestones for this trigger type",
                },
              ]}
              className="ToastError"
            />,
            {
              ...toastConfig,
            }
          );
        }
      }
      // Clear for next drag and drop
      setTempTriggerMilestoneId(null);
      setTempTriggerMilestoneData(null);
    }
  }, [tempTriggerMilestoneData]);

  const handleChangeMilestone = (tempTriggerMilestoneData: List | null) => {
    if (tempTriggerMilestoneData && parsedData) {
      const newValue = tempTriggerMilestoneData
        ? tempTriggerMilestoneData.tasksId
        : null;

      const matchType =
        unParsedTasksAndMilestones && typeof newValue === "number"
          ? unParsedTasksAndMilestones.filter(item => item.id === newValue)
          : null;

      if (
        Array.isArray(matchType) &&
        matchType.length === 1 &&
        matchType[0].type !== "task"
      ) {
        let newReferenceData = _.cloneDeep(referenceData);

        if (newReferenceData?.trigger) {
          newReferenceData.trigger.milestonesID = newValue;
        }

        setReferenceData(newReferenceData);
      } else if (
        Array.isArray(matchType) &&
        matchType.length === 1 &&
        matchType[0].type === "task"
      ) {
        toast(
          <ToastMessage
            toastData={[
              {
                title: "Only milestones allowed",
                text: "Please only use Milestones for this trigger type",
              },
            ]}
            className="ToastError"
          />,
          {
            ...toastConfig,
          }
        );
      }
    }
  };

  const handleChangeProject = (options: SelectOption[]) => {
    if (parsedData) {
      let newParsedData: any = _.cloneDeep(parsedData);

      const newValue = options ? options.map(item => item.value) : null;

      newParsedData.projectTypesIDs = newValue;

      setParsedData(newParsedData);

      let newReferenceData = _.cloneDeep(referenceData);

      if (newReferenceData?.trigger) {
        newReferenceData.trigger.projectTypesIDs = newValue;
      }

      setReferenceData(newReferenceData);
    }
  };

  const handleChangeTriggerDates = (option: SelectOption) => {
    if (parsedData) {
      let newParsedData: any = _.cloneDeep(parsedData);

      const newValue = option ? option.value : null;

      newParsedData.documentTypesID = newValue;

      setParsedData(newParsedData);

      let newReferenceData = _.cloneDeep(referenceData);

      if (newReferenceData?.trigger) {
        newReferenceData.trigger.triggerDates = newValue;
      }

      setReferenceData(newReferenceData);
    }
  };

  const handleBooleanChange = (fieldName: string) => {
    if (parsedData) {
      let newParsedData: any = {
        ...parsedData,
      };

      const newValue =
        newParsedData && newParsedData.hasOwnProperty(fieldName)
          ? !newParsedData[fieldName]
          : newParsedData && !newParsedData.hasOwnProperty(fieldName)
          ? true
          : false;

      newParsedData[fieldName] = newValue;

      setParsedData(newParsedData);

      let newReferenceData = _.cloneDeep(referenceData);

      if (newReferenceData?.trigger) {
        newReferenceData.trigger[fieldName] = newValue;
      }

      setReferenceData(newReferenceData);
    }
  };

  const title = "Milestone update";

  return (
    <div
      className={`MilestoneUpdateTrigger TriggerContainer DetailsItemContent ${
        relevantErrors && relevantErrors.length > 0 ? "Error" : ""
      }`}
    >
      <label className="Title">
        <div className="Text">{`Trigger - ${title}`}</div>

        <EditNode setShowSelector={setShowTriggerTypeSelector} />
      </label>

      <Droppable
        droppableId={`droppableId-milestoneUpdateTrigger-${parentOrderNumber}-${orderNumber}-${1}`}
        type={"group"}
      >
        {provided => (
          <div
            className="TaskMilestoneDropContainer"
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {!milestone && (
              <div className="PlaceholderText">
                Drag and drop Milestone here
              </div>
            )}

            {milestone && (
              <div className="MilestoneData">
                <img
                  src={dragAndDropIcon}
                  alt="drag and drop icon"
                  className="Icon"
                />

                <div className="Text">{`${milestone.label}`}</div>
              </div>
            )}
          </div>
        )}
      </Droppable>

      <div className="Row">
        <div className="Label">
          Project types
          {/* <span className="Italic"> - opt</span> */}
        </div>

        <MultiDropdown
          customClassName="MultiDropdown"
          onChange={handleChangeProject}
          value={
            triggerData &&
            triggerData.projectTypesIDs &&
            Array.isArray(triggerData.projectTypesIDs)
              ? projectOptions.filter(o =>
                  triggerData.projectTypesIDs.includes(o.value)
                )
              : null
          }
          options={projectOptions}
          placeholder="Please select"
          isClearable={true}
          roundedRectangle
          portalMode={true}
        />
      </div>

      <div className="Row">
        <div className="Label">Trigger date</div>

        <Dropdown
          onChange={handleChangeTriggerDates}
          value={
            triggerData && triggerData.triggerDates
              ? triggerDatesOptions.find(
                  o => o.value === triggerData.triggerDates
                )
              : null
          }
          options={triggerDatesOptions}
          placeholder="Please select"
          roundedRectangle
          portalMode={true}
          isClearable={true}
        />
      </div>

      <div className="Row">
        <div className="Label">Triggered by completing milestone</div>

        <div
          className="Radio"
          role="radio"
          aria-checked={
            triggerData && triggerData.bTriggeredByCompletingMilestone
          }
        >
          <input
            id={"bTriggeredByCompletingMilestoneCheckbox"}
            type="radio"
            name={"bTriggeredByCompletingMilestoneCheckbox"}
            value="bTriggeredByCompletingMilestone"
            onClick={() =>
              handleBooleanChange("bTriggeredByCompletingMilestone")
            }
            checked={triggerData && triggerData.bTriggeredByCompletingMilestone}
          />
          <label
            className="CustomInput"
            htmlFor={"bTriggeredByCompletingMilestoneCheckbox"}
          ></label>
        </div>
      </div>

      {relevantErrors && relevantErrors.length > 0 && (
        <div className="Errors">
          {relevantErrors.map(error => {
            return <div className="Error">{error}</div>;
          })}
        </div>
      )}
    </div>
  );
};

export default MilestoneUpdateTrigger;
